import { CALL_API } from '../middleware/ApiMiddleware';

export const DASHBOARD_FETCH_REQUEST = 'DASHBOARD_FETCH_REQUEST';
export const DASHBOARD_FETCH_SUCCESS = 'DASHBOARD_FETCH_SUCCESS';
export const DASHBOARD_FETCH_FAILURE = 'DASHBOARD_FETCH_FAILURE';

export const GET_QUEUED_NOTICES_REQUEST = 'GET_QUEUED_NOTICES_REQUEST';
export const GET_QUEUED_NOTICES_SUCCESS = 'GET_QUEUED_NOTICES_SUCCESS';
export const GET_QUEUED_NOTICES_FAILURE = 'GET_QUEUED_NOTICES_FAILURE';

export const PRINT_QUEUED_NOTICES_REQUEST = 'PRINT_QUEUED_NOTICES_REQUEST';
export const PRINT_QUEUED_NOTICES_SUCCESS = 'PRINT_QUEUED_NOTICES_SUCCESS';
export const PRINT_QUEUED_NOTICES_FAILURE = 'PRINT_QUEUED_NOTICES_FAILURE';

export const EDIT_CMN_REQUEST = 'EDIT_CMN_REQUEST';
export const EDIT_CMN_SUCCESS = 'EDIT_CMN_SUCCESS';
export const EDIT_CMN_FAILURE = 'EDIT_CMN_FAILURE';

export const fetchDashboardData = (params: IDashboardRequest) => ({
  [CALL_API]: {
    endpoint: 'dashboard',
    params,
    method: 'get',
    authenticated: true,
    types: [DASHBOARD_FETCH_REQUEST, DASHBOARD_FETCH_SUCCESS, DASHBOARD_FETCH_FAILURE],
  },
});

export const getQueuedNotices = (params: IQueuedNoticesFiltersRequest, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: 'xerce/notices/queued',
    method: 'post',
    body: params,
    authenticated: true,
    types: [GET_QUEUED_NOTICES_REQUEST, GET_QUEUED_NOTICES_SUCCESS, GET_QUEUED_NOTICES_FAILURE],
  },
});

export const printQueuedNotices = (
  fAADocuments: IQueuedNoticePrintType[] = [],
  inspectionNotices: IQueuedNoticePrintType[] = [],
  isQueued: boolean = false
) => ({
  [CALL_API]: {
    endpoint: 'xerce/notices/queued',
    method: 'put',
    authenticated: true,
    body: { fAADocuments, inspectionNotices, isQueued },
    types: [PRINT_QUEUED_NOTICES_REQUEST, PRINT_QUEUED_NOTICES_SUCCESS, PRINT_QUEUED_NOTICES_FAILURE],
  },
});

export const editCMN = (caseId: number, noticeId: number, certifiedMailNumber: string) => ({
  [CALL_API]: {
    endpoint: `xerce/cases/${caseId}/notice/${noticeId}`,
    method: 'put',
    authenticated: true,
    body: {
      certifiedMailNumber,
    },
    types: [EDIT_CMN_REQUEST, EDIT_CMN_SUCCESS, EDIT_CMN_FAILURE],
  },
});
